import { combineReducers } from 'redux';
import { cloneDeep } from 'lodash';

import {
	FETCH_DATA_SUCCESS,
	TOGGLE_TYPES,
	TOGGLE_TYPE,
	CLEAR_FILTERS,
	SET_FILTERED_TYPES,
	LOGOUT_USER,
	CLOSE_DROPDOWNS,
} from '../types';

const toggleType = (state, payload) => {
	const { id, selected } = payload;

	return {
		...state,
		[id]: { ...state[id], selected  }
	}
}

const deselectAllTypes = state => {
	const newTypes = cloneDeep(state);

	Object.entries(newTypes).forEach(([key, value]) => {
		value.selected = false;
	});
	return newTypes;
}

const byId = (state = {}, action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			return {
				...state,
				...action.payload.files.entities.types,
			}

		case TOGGLE_TYPE:
			return toggleType(state, action.payload);

		case CLEAR_FILTERS:
			return deselectAllTypes(state);

		case LOGOUT_USER:
			return {}

		default:
			return state;
	}
}

const allIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.types);
			return keys.map(Number);

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const filteredIds = (state = [], action) => {
	switch (action.type) {
		case FETCH_DATA_SUCCESS:
			const keys = Object.keys(action.payload.files.entities.types);
			return keys.map(Number);

		case SET_FILTERED_TYPES:
			return action.payload

		
		case CLEAR_FILTERS:
			return action.payload.types

		case LOGOUT_USER:
			return []

		default:
			return state;
	}
}

const metaInitialState = {
	active: false,
}

const meta = (state = metaInitialState, action) => {
	switch (action.type) {
		case TOGGLE_TYPES:
			return {
				...state,
				active: !state.active,
			}
		
		case CLEAR_FILTERS:
			return {
				...state,
				active: false,
			}

		case LOGOUT_USER:
			return metaInitialState;

		case CLOSE_DROPDOWNS:
			return metaInitialState
			
		default:
			return state;
	}
}

const types = combineReducers({
	byId,
	allIds,
	filteredIds,
	meta,
});
export default types;

export const getIsActive = state => state.meta.active;
export const getIds = state => state.allIds;
export const getFilteredIds = state => state.filteredIds;
export const getTypes = state => {
	const ids = getFilteredIds(state);
	const types = ids.map(id => state.byId[id]);

	return types.sort((a, b) => {
		var textA = a.title.toUpperCase();
		var textB = b.title.toUpperCase();
		return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	});
}
export const getSelectedTypes = state => {
	const ids = getIds(state);
	return ids.filter(id => state.byId[id].selected);
}


// WEBPACK FOOTER //
// ./src/store/types/reducer.js